import React from "react";
import { Grid, Button } from "@material-ui/core";
import Paper from '@mui/material/Paper';
import { useStyles } from "./styles";

const HomeVouchers = () => {
    const classesView = useStyles();
    return (
        <div className={classesView.root}>

            <Grid container spacing={1} xs={12}>
                {/* <div className={classesView.curve}></div> */}
                <Grid item xs={3}>
                    <Paper className={classesView.paper}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                        >
                            <Grid item>
                                <h4>Factura</h4>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Operación Interna
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Importación
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Exportación
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Zona Franca
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={3}>
                    <Paper className={classesView.paper}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                        >
                            <Grid item>
                                <h4>Nota de Débito</h4>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Referentre a una o varias FE
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Genérica
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={3}>
                    <Paper className={classesView.paper}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-around"
                            alignItems="center"
                            spacing={1}
                        >
                            <Grid item>
                                <h4>Nota de Crédito</h4>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Referentre a una o varias FE
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Genérica
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={3}>
                    <Paper className={classesView.paper}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                        >
                            <Grid item>
                                <h4>Reembolso</h4>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" className={classesView.buttonLogin}>
                                    Reembolso
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </div >
    );
};

export default HomeVouchers;